<template>
  <div class="content">
    <img :src="objImg" alt="">
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import detail from "@/js/detail.js";
export default {
  data() {
    return {
      objImg:''
    };
  },
  created() {
    let that = this;
    $init(() => {
      let nId = that.$route.query.nId;
      that.getShareImg(nId);
    });
  },
  methods: {
    getShareImg(id) {
      let that = this;
      that.$store.commit("loadSwitch", true);
      detail.getShareImg({ nId: id }).then((res) => {
        let img = new Image();
        let image_url = res.result.image_url;
        img.onload = () => {
          that.objImg = image_url;
          that.$store.commit("loadSwitch", false);
          Toast({
            message: "您可长按保存图片",
            duration: 3000,
          });
        };
        img.src = image_url;
        //  console.log("图片路径", res.result.image_url);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content{
  width: 100%;
  min-height: 100vh;
  img{
    width: 100%;
  }
}
</style>
